<template>
    <div class="form-check">
        <input
            class="form-check-input"
            :class="onGetClasses"
            type="checkbox"
            :id="id"
            :name="name"
            :disabled="disabled"
            :checked="checked"
            @input="$event => selected = $event.target.checked"
            :data-automation="`checkbox-${ id }`"
        >

        <label class="form-check-label" :for="id">
            {{ titleElement }}
        </label>
    </div>
</template>

<script>
    import { computed } from 'vue';
    import { formProps } from '@/mixins';
    import { useVFInput } from '@/composables';

    export default {
        name: "VF-checkbox",
        props: {
            checked: {
                type: Boolean,
                default: false
            }
        },
        mixins: [
            formProps
        ],
        setup(props, { emit }) {
            const {
                modelValue,
                onGetClasses,
                onUpdateModelValue
            } = useVFInput(props, emit);

            const selected = computed({
                get() {
                    return modelValue.value;
                },
                set(val) {
                    emit('update:modelValue', val);
                }
            });

            return {
                selected,
                onGetClasses,
                onUpdateModelValue
            };
        }
    };
</script>
